const INITIAL_STATE = {
  minimized: true,
};

/**
 * Types
 */
export const Types = {
  SET_MENU: 'menu/SET_MENU',
};

/**
 * Reducer
 */
export default function menu(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.SET_MENU: {
      return { ...state, minimized: action.payload };
    }
    default:
      return state;
  }
}

/**
 * Actions Creators
 */
export const Creators = {
  setMenu: payload => ({
    type: Types.SET_MENU,
    payload,
  }),
};
